import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import styles from '@features/navigation/components/Navigation/Navigation.styles';
import { BASE_PATH } from '@config/index';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
const SimpleNavigationMobile = () => {
  const {
    t
  } = useTranslation('common');
  return <div sx={styles.simpleNavigationMobileContentContainer}>
      <div sx={styles.menuLogoMobile}>
        <Link href="/" prefetch={false}>
          <ResponsiveImage dataCy="logoIcon" image={`${BASE_PATH}/img/logo.svg`} alt={t('logoIconAlt')} priority objectFit="contain" />
        </Link>
      </div>
    </div>;
};
export default SimpleNavigationMobile;